import getApp from "./qapp";
import qSessionObject from "./qSessionObject";
import React from 'react';
import ReactDOM from 'react-dom';

//Session object definitions
let candidateCube = new qSessionObject({
  qDimensions: [{
    qDef: {
      qFieldDefs: ["[Leadership_candidate]"]
    }
  }],
  qMeasures: [{
    qDef: {
      qDef: "Sum({<[Leadership_candidate]=>} Total_amount_of_contribution)",
      qNumFormat: {
        qType: "M",
        qFmt: "$#,##0",
        qUseThou: true,
        qDec: ".",
        qThou: ","
      }
    },
    qSortBy: {
      qSortByNumeric: -1
    }
  }, {
    qDef: {
      qDef: "Count({<[Leadership_candidate]=>} Total_amount_of_contribution)",
      qNumFormat: {
        qType: "M",
        qFmt: "#,##0",
        qUseThou: true,
        qDec: ".",
        qThou: ","
      }
    }
  }, {
    qDef: {
      qDef: "Avg({<[Leadership_candidate]=>} Total_amount_of_contribution)",
      qNumFormat: {
        qType: "M",
        qFmt: "$#,##0",
        qUseThou: true,
        qDec: ".",
        qThou: ","
      }
    }
  }, {
    qDef: {
      qDef: "only({<[Leadership_candidate]=>} R&','&G&','&B)",
    }
  },{
    qDef: {
      qDef: "only({<[Leadership_candidate]=, RH1W1=, Province=, City=, ZIP=, [Postal_code]=>} 0)"
    }
  }],
  qInterColumnSortOrder: [1,0,2,3,4],
  qInitialDataFetch: [{
    qWidth: 5,
    qHeight: 15
  }]
});

//React cards
class Card extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={`card ${this.props.row[0].qState} ${this.props.active ? 'active' : 'inactive'}`} style={this.props.borderTopStyle} onClick={(e) => this.handleClick(e)}>
        <div className="card-img-container" style={this.props.borderStyle}>
          <img className="card-img" src={`img/${this.props.row[0].qText}.png`} />
        </div>
        <div className="card-title">
          <div>{this.props.row[0].qText.split(" ")[0]}</div>
          <div className="lastname">{this.props.row[0].qText.split(" ")[1]}</div>
        </div>
        <div className="card-kpis">
          <div className="kpi">
            <div>Amount</div>
            <div className="value">{this.props.row[1].qText}</div>
          </div>
          <div className="kpi">
            <div>Average</div>
            <div className="value"> {this.props.row[3].qText}</div>
          </div>
          <div className="kpi">
            <div>Donations</div>
            <div className="value"> {this.props.row[2].qText}</div>
          </div>
        </div>
      </div>
    );
  }
  handleClick() {
    candidateCube.object.selectHyperCubeValues("/qHyperCubeDef", 0, [this.props.row[0].qElemNumber], true);
  }
}
function renderCards() {
  let cards = candidateCube.object.layout.qHyperCube.qDataPages[0].qMatrix.map((row, i) => {
    let borderStyle = {
      border: `1px solid rgb(${row[4].qText})`
    }
    let borderTopStyle = {
      borderTop: `6px solid rgb(${row[4].qText})`
    }
    return <Card row={row} borderStyle={borderStyle} borderTopStyle={borderTopStyle} active={row[1].qNum > 0} key={i} />
  });
  ReactDOM.render(
    <div className="cards">{cards}</div>,
    document.getElementById('cards-container')
  );
}

//Render cards
$(() => {
  candidateCube.open().then(() => {
    renderCards();
    candidateCube.object.Validated.bind(() => {
      renderCards();
    });
  });
});

//Load and render filters, map, and charts
$(() => {
  getApp.then((app) => {
    if($("body").width() > 768) {
      app.visualization.get('a596f462-2125-4a00-b904-b7a9a06382d3').then((viz) => {
        viz.show('map');
      });
      app.visualization.get('853f831b-d2eb-4489-9f1d-c5361a245252').then((viz) => {
        viz.show('layer');
      });
    } else {
      app.visualization.get('ab9d3cab-1429-4ed2-bbe0-0773d759f89f').then((viz) => {
        viz.show('map');
      });
      app.visualization.get('4b1347b6-0ee4-4fff-8710-f5ea53714497').then((viz) => {
        viz.show('layer');
      });
    }
    app.visualization.get('JUkzpx').then((viz) => {
      viz.show('province-filter');
    });
    app.visualization.get('jEJvQ').then((viz) => {
      viz.show('city-filter');
    });
    if($("body").width() > 768) {
      app.visualization.get('EaReZu').then((viz) => {
        viz.show('postal-filter');
      });
    } else {
      app.visualization.get('fwqeQJ').then((viz) => {
        viz.show('postal-filter');
      });
    }
    app.visualization.get('ZZqBx').then((viz) => {
      viz.show('barchart1');
    });
    app.visualization.get('JPPDks').then((viz) => {
      viz.show('barchart2');
    });
  });
});

// Control buttons
$(()=>{
  getApp.then((app) => {
    $('#reset').click(() => {
      app.clearAll();
    });
    $("#back").click(() => {
      app.back();
    });
    $("#forward").click(() => {
      app.forward();
    });
  });
});

//Load Screen
Promise.all([getApp, candidateCube]).then(() => {
  $("#load-screen").fadeOut();
});

//Event tracking
$(() => {
  $(".qlik-link").click(() => {
    ga('send', 'event', 'interaction', 'click', 'Qlik Logo');
  });
  $(".filter").click(() => {
    ga('send', 'event', 'interaction', 'click', 'Filter');
  });
  $(".control-button").click(() => {
    ga('send', 'event', 'interaction', 'click', 'Controls');
  });
  $("#map").click(() => {
    ga('send', 'event', 'interaction', 'click', 'Map');
  });
  $(".card").click(() => {
    ga('send', 'event', 'interaction', 'click', 'Card');
  });
});


// WEBPACK FOOTER //
// ./main.js